import React from 'react';
import classnames from 'classnames';
import { materialThicknessOptions } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const MaterialThickness = (props) => {
  const name = 'material_thickness';

  const {
    onChangeParameter,
    label,
    required,
    options,
    tooltip,
    parameters,
    groupName,
    className,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      className={classnames('material-type', className)}
      disabled={disabled} />
  );
};

MaterialThickness.defaultProps = {
  label: Spree.translations.parameters.material_thickness,
  options: materialThicknessOptions,
  name: 'material_thickness',
  tooltip: Spree.helpForParameters.material_thickness,
};

export default MaterialThickness;
